module.exports = __webpack_public_path__ + "assets/img/homepage_body_bg_yellow.webp?f87c3406335cb78b1f41b748e962c860";